import localeEnGB from '@/locales/en-GB.json'
import localeEnIE from '@/locales/en-IE.json'
import localeEnClub from '@/locales/en-club.json'
import localeEn from '@/locales/en.json'
import { ThemeType, getTheme } from '@goodlifeplus/themes'
import type { SiteId } from '@goodlifeplus/themes/types'
import {
  type DefaultDateTimeFormatSchema,
  type DefaultNumberFormatSchema,
  type Locale,
  createI18n,
} from 'vue-i18n'

type MessageSchema = typeof localeEnGB.messages

export const i18n = createI18n<[MessageSchema], Locale>({
  locale: import.meta.env.GLP_LOCALE || 'en-GB',
  fallbackLocale: 'en-GB',
  legacy: true,
  globalInjection: true,
  warnHtmlMessage: false,
  messages: {
    'en-GB': localeEnGB.messages,
    'en-IE': localeEnIE.messages,
  },
  missing: (locale, key) => {
    console.error(
      'Translation not found! Locale:',
      locale,
      'Translation key:',
      key
    )
  },
  numberFormats: {
    'en-GB': localeEnGB.numberFormats as DefaultNumberFormatSchema,
    'en-IE': localeEnIE.numberFormats as DefaultNumberFormatSchema,
  },
  datetimeFormats: {
    'en-GB': localeEn.datetimeFormats as DefaultDateTimeFormatSchema,
    'en-IE': localeEn.datetimeFormats as DefaultDateTimeFormatSchema,
  },
})

// TODO: reduce conditionals
if (getTheme(import.meta.env.GLP_SITE_ID as SiteId).type === ThemeType.Club) {
  i18n.global.mergeLocaleMessage(
    'en-GB',
    localeEnClub.messages as Partial<MessageSchema>
  )
}
